import React,{useState} from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
const RestarauntMenu = () => {
    const[food,setFood]=useState(true)
    const[beverages,setBeverages]=useState(false)
    
  return (
    <div>
       
        <div className="h-3/4 bg bg-cover bg-center">
        <div className="h-full z-10 overlay">
            <Nav color={true}/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-5xl">RESTAURANT MENU</p>
          </div>
          </div>
          </div>
          <div className="m-0 w-full bg-black p-5 ">
          <div className="container w-4/5 mx-auto p-6 border-b-2 border-gray-500">
            <div className="flex justify-center flex-wrap text-white text-2xl p-5 m-5 ">

            <div className="p-5 active:border-b-2 border-[#d2a960]" onClick={(e)=>{setFood(true)}}>Food</div>
            <div className="p-5 active:border-b-2 border-[#d2a960]"onClick={(e)=>{setFood(false)}}>Beverages</div>
            <div className="p-5 active:border-b-2 border-[#d2a960]"onClick={(e)=>{setFood(true)}}>Food</div>
            <div className="p-5 active:border-b-2 border-[#d2a960]"onClick={(e)=>{setFood(false)}}>Beverages</div>
            </div>
            {food ?(
             <div className="flex justify-between flex-wrap text-white">
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>

             
             
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>

                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
          </div>):(
            <div className="flex justify-between flex-wrap text-white">
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>

             
             
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>

                <div className="p-5">
                    <div className="text-3xl py-2 font-semibold">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <div>English muffin, beef, hollandaise sauce, poached egg, English muffin, beef, hollandaise sauce, poached egg.</div>
                </div>
                <div className="p-5 align-middle text-4xl">$12</div>
          </div>
          )}
          </div>
          <div className="p-5 text-center">
            <div className="pt-6 text-3xl font-medium text-white"> The Soul Street Experience</div>
            <div className="w-1/6 mx-auto m-5 border-t-4 border-[#d2a960]"></div>
          </div>
         
          <div className="p-5 text-center text-white pb-10">
            <div className="text-2xl "> Ladies night | Wednesday, 7pm - 10pm
</div>
<div className="text-2xl p-5">Nomad brunch | Saturday, 1pm - 4pm</div>
          </div>
          </div>
          <Footer isColour={true}/>
          </div>
  )
}
export default RestarauntMenu